import { z } from 'zod';

export const createOfferSchema = z.object({
  venue_id: z.number({
    required_error: 'Venue is required',
    invalid_type_error: 'Venue is required',
  }).positive('Venue is required'),
  
  short_description: z.string()
    .min(1, 'Short description is required')
    .max(255, 'Short description must be 255 characters or less'),
  
  detailed_description: z.string()
    .min(1, 'Detailed description is required')
    .max(1000, 'Detailed description must be 1000 characters or less'),
  
  media_url: z.string()
    .min(1, 'Media URL is required')
    .url('Media URL must be a valid URL'),
  
  expires_at: z.date({
    required_error: 'Expiry date is required',
    invalid_type_error: 'Invalid expiry date',
  }).refine(
    (date) => date > new Date(),
    'Expiry date must be in the future'
  ),
  
  claim_frequency: z.number({
    required_error: 'Claim frequency is required',
    invalid_type_error: 'Claim frequency must be a number',
  })
    .int('Claim frequency must be a whole number')
    .min(1, 'Claim frequency must be at least 1')
    .max(100, 'Claim frequency must be 100 or less'),
  
  farming_time_in_hours: z.number({
    required_error: 'Farming time is required',
    invalid_type_error: 'Farming time must be a number',
  })
    .int('Farming time must be a whole number')
    .min(0, 'Farming time must be 0 or more')
    .max(168, 'Farming time must be 168 hours (7 days) or less'),
  
  is_active: z.boolean().default(true),
});

export const updateOfferSchema = z.object({
  short_description: z.string()
    .min(1, 'Short description is required')
    .max(255, 'Short description must be 255 characters or less')
    .optional(),
  
  detailed_description: z.string()
    .min(1, 'Detailed description is required')
    .max(1000, 'Detailed description must be 1000 characters or less')
    .optional(),
  
  media_url: z.string()
    .min(1, 'Media URL is required')
    .url('Media URL must be a valid URL')
    .optional(),
  
  expires_at: z.date({
    invalid_type_error: 'Invalid expiry date',
  }).refine(
    (date) => date > new Date(),
    'Expiry date must be in the future'
  ).optional(),
  
  claim_frequency: z.number({
    invalid_type_error: 'Claim frequency must be a number',
  })
    .int('Claim frequency must be a whole number')
    .min(1, 'Claim frequency must be at least 1')
    .max(100, 'Claim frequency must be 100 or less')
    .optional(),
  
  farming_time_in_hours: z.number({
    invalid_type_error: 'Farming time must be a number',
  })
    .int('Farming time must be a whole number')
    .min(0, 'Farming time must be 0 or more')
    .max(168, 'Farming time must be 168 hours (7 days) or less')
    .optional(),
  
  is_active: z.boolean().optional(),
});

export type CreateOfferInput = z.infer<typeof createOfferSchema>;
export type UpdateOfferInput = z.infer<typeof updateOfferSchema>;